module.exports = "https://cdn.hellotech.com/client-assets/SmartCam_5ce8980e69d72133470795c1dd5f66b0.png";